import {
  AssetType,
  Button,
  CloseIcon,
  ConsentOrdersPathName,
  FormNavigation,
  VehicleBaseProps,
  VehicleProps,
  Vehicle_InitialState,
  toast
} from "@fla/components";
import { useConsentOrders } from "hooks/ConsentOrders";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { formSteps } from "./steps";

const initialState = {
  make_model_year: "",
  registration: "",
  owner: "",
  value: "",
  split_by: "",
  sale_proceeds: "",
  percentage: {
    user: "",
    spouse: ""
  },
  comment: ""
};

export default function AddRealEstate() {
  const location = useLocation() as { state: { child: Vehicle_InitialState; parent: VehicleBaseProps } };
  const editData = location.state?.child;

  const navigation = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [formState, setFormState] = useState(
    useMemo(() => {
      if (editData?.id) {
        const obj = Object.assign({}, editData);
        delete obj.id;
        delete obj.uid;
        delete obj.createdAt;
        delete obj.type;

        return obj;
      } else {
        return initialState;
      }
    }, [editData])
  );

  const CurrentTab = formSteps[currentStep as keyof typeof formSteps];

  const isLastStep = () => currentStep === Object.keys(formSteps).length;
  const isFirstStep = () => currentStep === 1;

  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const { addAsset, deleteAsset, isDeleting, isSubmitting } = useConsentOrders();

  const handleBackClick = () => {
    if (!isFirst) {
      setCurrentStep(prev => prev - 1);
    } else {
      navigation(ConsentOrdersPathName.Vehicle, {
        state: location.state?.parent,
        replace: true
      });
    }
  };

  const onSubmit = async (formData: VehicleProps) => {
    setFormState(prevState => ({ ...prevState, ...formData }));

    if (!isLast) setCurrentStep(prev => prev + 1);
    else {
      try {
        addAsset({
          ...formData,
          type: AssetType.VEHICLE,
          id: editData?.id
        });
      } catch (error: any) {
        toast({
          type: "error",
          message: error?.message || "something went wrong, please try again!"
        });
      }
    }
  };

  const onDelete = () => {
    if (editData?.id) deleteAsset(editData.id);
  };

  return (
    <section className="w-full h-[calc(100vh_-_64px)] md:h-screen overflow-y-auto">
      <section className="w-full md:w-10/12 lg:max-w-2xl mx-auto my-10">
        <div className="md:bg-white rounded-xl w-full h-fit px-10 py-5 md:shadow-md mx-auto">
          <CurrentTab formId="add-bank" store={formState} onSubmit={onSubmit} />

          {editData?.id ? (
            <Button
              className="mx-auto mt-10 mb-32 px-7 py-2 space-x-2 flex items-center group uppercase"
              isSubmitting={isDeleting}
              onClick={onDelete}
              // btnType="danger"
              // appearance="outline"
            >
              <CloseIcon classes="fill-current group-hover:text-white text-red-500" />
              <p>Delete Vehicle</p>
            </Button>
          ) : null}

          <FormNavigation
            isFirst={false}
            isLast={isLast}
            form="add-bank"
            handleBackClick={handleBackClick}
            nextButtonText="Continue"
            isSubmitting={isSubmitting}
            classes="mt-12"
          />
        </div>
      </section>
    </section>
  );
}
